import { render, staticRenderFns } from "./GoogleSlidesContentTab.vue?vue&type=template&id=96ad379c&scoped=true&"
import script from "./GoogleSlidesContentTab.vue?vue&type=script&lang=js&"
export * from "./GoogleSlidesContentTab.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSlidesContentTab.vue?vue&type=style&index=0&id=96ad379c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ad379c",
  null
  
)

export default component.exports